import { IHttpRequest, IHttpResponse } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";

import { AudienceModalState } from  "@/interfaces/ContentAudienceModal";
import { ContentAudienceSearchParams, IAudienceCounts, IGroups, IUsers } from  "@/interfaces/api/ContentAudience";
import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";
import { ResourcePermission } from  "@/interfaces/orgSettings";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

type StringOrInt = string | number

export async function getAudienceCounts(contentId: StringOrInt): Promise<IAudienceCounts> {
    const res = await http.get(`content/${contentId}/Audience/counts`)
    
    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get audience count`))
}

export async function getAudienceGroupsForEdit(contentId: StringOrInt, options?:ContentAudienceSearchParams): Promise<PaginatedResponse<IGroups>> {
    const res = await http.get(`content/${contentId}/audience/groups`, {params: options || {}})

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get user groups for content`))
}

export async function getAudienceUsersForEdit(contentId: StringOrInt, options?:ContentAudienceSearchParams): Promise<PaginatedResponse<IUsers>> {
    const res = await http.get(`content/${contentId}/audience/users`, {params: options || {}})

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get users for content`))
}

export async function getAudienceGroupsForAdd(contentId: StringOrInt, options?:ContentAudienceSearchParams): Promise<PaginatedResponse<IGroups>> {
    const res = await http.get(`content/${contentId}/audience/groups/availableToAdd`, {params: options || {}})

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get user groups for content`))
}

export async function getAudienceUsersForAdd(contentId: StringOrInt, options?:ContentAudienceSearchParams): Promise<PaginatedResponse<IUsers>> {
    const res = await http.get(`content/${contentId}/audience/users/availableToAdd`, {params: options || {}})
    
    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get users for content`))
}

export async function setGroupPermissions(contentId: number, groupId: number, permission: ResourcePermission){
    const res = await http.put(`content/${contentId}/audience/groups/permission`, {permission, groupId});

    if(res.status === 200) {
        return Promise.resolve(true)
    }
    
    return Promise.reject(new Error(`Couldn't update userGroup permission change`))
}

export async function setUserPermissions(contentId: number, userId: number, permission: ResourcePermission){
    return http.put(`content/${contentId}/audience/users/permission`, {permission, userId})
}

export async function resetToParentPermissions(contentId: StringOrInt): Promise<IHttpResponse>{
    return  http.put(`content/${contentId}/audience`, {});
}

export async function removeUserPermissions(contentId: number, userId: number) {
    return http.delete(`content/${contentId}/audience/user/${userId}`)
}


export async function removeGroupPermissions(contentId: number, groupId: number) {
    return http.delete(`content/${contentId}/audience/group/${groupId}`)
}

export async function removeAllPermissions(contentId: StringOrInt): Promise<IHttpResponse>{
    return  http.delete(`content/${contentId}/audience`);
}

export async function getGroupsForUser(contentId: StringOrInt, userId: StringOrInt): Promise<PaginatedResponse<IGroups>> {
    const res = await http.get(`content/${contentId}/audience/groups/usergroups/${userId}?top=5`)

    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get groups for user`))
}


export const AddEditAPIMap: { [key in AudienceModalState.AddAudience | AudienceModalState.EditAudience]: {Groups: Function, Users: Function}} = {
    [AudienceModalState.AddAudience]:{
        Groups: getAudienceGroupsForAdd,
        Users: getAudienceUsersForAdd

    },
    [AudienceModalState.EditAudience]:{
        Groups: getAudienceGroupsForEdit,
        Users: getAudienceUsersForEdit
    }
}
    
    